import { type FlexflowCardStatus } from '../types';

export type CardDetailsGroup = {
  cardToken: string;
  status: CardStatusToDisplay;
  createdAt: string;
  lastFour: string;
  isSwanCard: boolean;
  physicalCard?: {
    status: CardStatusToDisplay;
    requestedAt: string;
    lastFour: string;
    suspendedBySwanAt?: string;
  };
};

export enum NotRequestedCardStatus {
  NOT_REQUESTED = 'notRequested'
}
export type CardStatusToDisplay = FlexflowCardStatus | NotRequestedCardStatus;
